
function chartData(data) {

    // data = [
    // book {}
    // completed
    // coverData
    // currentlyReading
    // dateAdded
    // dateCompleted
    // email
    // id
    // notes
    // rating
    // ]

    let readBooks = getReadBooks(data);
    // let readingBooks = getReadingBooks(data);
    let unreadBooks = getUnreadBooks(data);
    // let averageBooksPerMonthThisYear = getAverageBooksPerMonthThisYear(readBooks);
    // let averageTimeBetweenStartingAndFinishingThisYear = getAverageTimeBetweenStartingAndFinishingThisYear(readBooks);

    // let allBookTypes = getAllBookTypes(data);
    // let topThreeBookTypes = allBookTypes.slice(0, 3);

    return {
        "totalRead": readBooks.length,
        "percentageOfLibraryRead": unreadBooks.length === 0 ? 0 : Math.round((readBooks.length / (readBooks.length + unreadBooks.length)) * 100),
        "booksReadByYear": getBooksReadByYear(readBooks),
        "topGenres": getTopGenres(data),
        // "percentageOfLibraryUnread": unreadBooks.length === 0 ? 0 : Math.round((unreadBooks.length / (readBooks.length + unreadBooks.length)) * 100),
        // "percentageOfLibraryReading": readingBooks.length === 0 ? 0 : Math.round((readingBooks.length / (readBooks.length + unreadBooks.length + readingBooks.length)) * 100),
        // "getReadingBooks": readingBooks.length,
        // "totalUnread": unreadBooks.length,
        // "readThisMonth": getBooksReadThisMonth(readBooks).length,
        // "readLastMonth": getBooksReadLastMonth(readBooks).length,
        // "readThisYear": getBooksReadThisYear(readBooks).length,
        // "chartDataForThisYear": chartDataForThisYear(readBooks),
        // "allBookTypes": allBookTypes,
        // "allBookTypesChartData": chartDataForAllBookTypes(allBookTypes),
        // "topThreeBookTypes": topThreeBookTypes,
        "thisYear": thisYear(),
        // "averageBooksPerMonthThisYear": averageBooksPerMonthThisYear,
        // "averageTimeBetweenStartingAndFinishingThisYear": averageTimeBetweenStartingAndFinishingThisYear,
        // "timeSpentReadingMeasurement": "hours",
    };
}

function getReadBooks(data) {
    return data.filter(book => book.completed);
}

// function getReadingBooks(data) {
//     return data.filter(book => book.currentlyReading);
// }

function getUnreadBooks(data) {
    return data.filter(book => !book.completed && !book.currentlyReading);
}

// function getBooksReadThisMonth(data) {
//     let today = new Date();
//     let thisMonth = today.getMonth();
//     let thisYear = today.getFullYear();
//     return data.filter(book => {
//         let dateCompleted = book.dateCompleted.toDate();
//         let bookMonth = dateCompleted.getMonth();
//         let bookYear = dateCompleted.getFullYear();
//         return bookMonth === thisMonth && bookYear === thisYear;
//     });
// }

// function getBooksReadLastMonth(data) {
//     let today = new Date();
//     let thisMonth = today.getMonth();
//     let thisYear = today.getFullYear();
//     let lastMonth = thisMonth - 1;
//     if (lastMonth < 0) {
//         lastMonth = 11;
//         thisYear = thisYear - 1;
//     }
//     return data.filter(book => {
//         let dateCompleted = book.dateCompleted.toDate();
//         let bookMonth = dateCompleted.getMonth();
//         let bookYear = dateCompleted.getFullYear();
//         return bookMonth === lastMonth && bookYear === thisYear;
//     });
// }

// function getBooksReadThisYear(data) {
//     return data.filter(book => {
//         let dateCompleted = book.dateCompleted?.toDate();
//         let bookYear = (dateCompleted) ? dateCompleted.getFullYear() : 0;
//         return bookYear === thisYear();
//     });
// }

function getBooksReadByYear(data) {
    let booksByYear = {};
    data.forEach(book => {
        let dateCompleted = book.dateCompleted?.toDate();
        if (dateCompleted) {
            let year = dateCompleted.getFullYear();
            if (booksByYear[year]) {
                booksByYear[year]++;
            } else {
                booksByYear[year] = 1;
            }
        }
    });

    let chartData = [];
    for (const year in booksByYear) {
        chartData.push({year: year, count: booksByYear[year]});
    }

    chartData.sort((a, b) => {
        return a.year - b.year;
    });

    return chartData;
}

function getTopGenres(data) {
    let genreCounts = {};
    data.forEach(book => {
        if (book.book.subject) {
            book.book.subject.forEach(subject => {
                // Clean up subject strings
                let cleanedSubject = subject.toLowerCase()
                    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters except spaces and hyphens
                    .replace(/\s+/g, ' ') // Replace multiple spaces with a single space
                    .trim();

                // Split by common delimiters
                let genres = cleanedSubject.split(/[,/]/).map(g => g.trim()).filter(g => g.length > 0).filter(g => g !== ''); // Ensure genre is not empty after trimming
                if (genres.length > 0) {
                    genres.forEach(genre => {
                        if (genreCounts[genre]) {
                            genreCounts[genre]++;
                        } else {
                            genreCounts[genre] = 1;
                        }
                    });
                }
            });
        }
    });

    let chartData = [];
    for (const genre in genreCounts) {
        chartData.push({genre: genre, count: genreCounts[genre]});
    }

    chartData.sort((a, b) => {
        return b.count - a.count;
    });

    // limit to 5
    chartData = chartData.slice(0, 5);

    return chartData;
}


// function getAverageBooksPerMonthThisYear(readBooks) {
//     let today = new Date();
//     let thisMonth = today.getMonth();
//     let booksReadThisYear = getBooksReadThisYear(readBooks);
//     let booksByMonth = {};
//     for (let i = 0; i < 12; i++) {
//         booksByMonth[i] = 0;
//     }
//
//     booksReadThisYear.forEach(book => {
//         let month = book.dateCompleted.toDate().getMonth();
//         booksByMonth[month]++;
//     });
//
//     let totalBooksReadThisYear = booksReadThisYear.length;
//     let monthsSoFar = thisMonth + 1;
//     return totalBooksReadThisYear / monthsSoFar;
// }

// function getAverageTimeBetweenStartingAndFinishingThisYear(readBooks) {
//     let booksReadThisYear = getBooksReadThisYear(readBooks);
//     let totalBooksReadThisYear = booksReadThisYear.length;
//     let totalHoursSpentReading = 0;
//     booksReadThisYear.forEach(book => {
//         let dateCompleted = book.dateCompleted.toDate();
//         let dateAdded = book.dateAdded.toDate();
//         let timeSpentReading = dateCompleted - dateAdded;
//         totalHoursSpentReading += timeSpentReading;
//     });
//
//     let averageTimeSpentReading = totalHoursSpentReading / totalBooksReadThisYear;
//     let hours = averageTimeSpentReading / 1000 / 60 / 60;
//     return round(hours, 1);
// }

// function getAllBookTypes(data) {
//     // want to return an array of all the book types and their counts
//
//     let bookTypes = [];
//     data.forEach(book => {
//         let subjects = book.book.subject; // array
//
//         if (subjects) {
//             let splitSubjects = [];
//             subjects.forEach(subject => {
//                 if (subject.includes(',')) {
//                     let split = subject.split(',');
//                     splitSubjects = splitSubjects.concat(split);
//                     let index = subjects.indexOf(subject);
//                     subjects.splice(index, 1);
//                 }
//                 if (subject.includes(' / ')) {
//                     let split = subject.split(' / ');
//                     splitSubjects = splitSubjects.concat(split);
//                     let index = subjects.indexOf(subject);
//                     subjects.splice(index, 1);
//                 }
//             });
//
//             subjects = subjects.concat(splitSubjects);
//
//             subjects.forEach(type => {
//                 // if it has a : or = in it, skip it
//                 if (type.includes(':') || type.includes('=')) {
//                     return;
//                 }
//
//                 let found = false;
//                 type = type.toLowerCase();
//                 type = type.replace(/-/g, '');
//                 // remove any space at the front
//                 type = type.replace(/^\s+/, '');
//
//                 if (type === "sciencefiction") {
//                     type = "science fiction";
//                 }
//
//                 bookTypes.forEach(bookType => {
//                     if (bookType.type === type) {
//                         bookType.count++;
//                         found = true;
//                     }
//                 });
//                 if (!found) {
//                     bookTypes.push({ type: type, count: 1 });
//                 }
//             });
//         }
//     });
//
//     // sort by count
//     bookTypes.sort((a, b) => {
//         return b.count - a.count;
//     });
//
//
//     // go over list, if the count is 1, remove it and add to 'other'
//     let other = 0;
//     let newBookTypes = [];
//
//     bookTypes.forEach(bookType => {
//         if (bookType.count === 1) {
//             other++;
//         } else {
//             newBookTypes.push(bookType);
//         }
//     } );
//
//
//     newBookTypes.push({ type: "other", count: other });
//
//     bookTypes = newBookTypes;
//
//     return bookTypes;
// }

// function chartDataForAllBookTypes(allBookTypes) {
//     let dataForSeries = [];
//
//     allBookTypes.forEach((bookType, index) => {
//         dataForSeries.push({ id: index, value: bookType.count, label: bookType.type });
//     });
//
//     return dataForSeries;
// }

// function round(value, decimals) {
//     return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
// }

function thisYear() {
    let today = new Date();
    return today.getFullYear();
}

// function chartDataForThisYear(data) {
//     let xAxis = [
//         {
//             id: 'x',
//             data: getMonthsSoFar(),
//             scaleType: 'band',
//         },
//     ];
//
//     let booksReadThisYear = getBooksReadThisYear(data);
//     let booksByMonth = {};
//     for (let i = 0; i < 12; i++) {
//         booksByMonth[i] = 0;
//     }
//
//     booksReadThisYear.forEach(book => {
//         let month = book.dateCompleted.toDate().getMonth();
//         booksByMonth[month]++;
//     });
//
//     let dataForSeries = [];
//     for (let i = 0; i < 12; i++) {
//         dataForSeries.push(booksByMonth[i]);
//     }
//
//     return {
//         xAxis: xAxis,
//         series: dataForSeries
//     };
// }

// function getMonthsSoFar() {
//     let today = new Date();
//     let thisMonth = today.getMonth();
//     let months = [];
//     for (let i = 0; i <= thisMonth; i++) {
//         let month = getNiceMonthName(i);
//         months.push(month);
//     }
//     return months;
// }

// function getNiceMonthName(month) {
//     let monthNames = [
//         "Jan",
//         "Feb",
//         "Mar",
//         "Apr",
//         "May",
//         "Jun",
//         "Jul",
//         "Aug",
//         "Sep",
//         "Oct",
//         "Nov",
//         "Dec",
//     ];
//     return monthNames[month];
// }

export default chartData;